import { Fragment, useContext, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import ProcessContext from '../../../contexts/process/ProcessContext';
import UIContext from '../../../contexts/ui/UIContext';
import StatusBarButton from '../../layout/StatusBarButton';
import NumberPad from '../../ui-elements/NumberPad';
import Loading from '../../ui-elements/Loading';

const NumPlantsPerChannel = ( forwardTo ) => {
  const { activeProcessId, continueProcess, notifyError } = useContext(ProcessContext);
  const { loading } = useContext(UIContext);
  const navigate = useNavigate();

  const [display, setDisplay] = useState({
    prefix: '',
    value: '',
  });

  const proceed = useCallback(async () => {
    try {
      await continueProcess(activeProcessId, display.value)
      .then(() => {
        if (forwardTo){
          navigate(forwardTo);
        }
      });
    } catch (error) {
      notifyError(<>We have encountered a problem while continuing the Process. Please contact the support team {HELP_DESK_LINK}.</>)
      console.error(error);
    }
  }, [activeProcessId, continueProcess, display.value, navigate]);

  const setValue = (value, setDisplay) => {
    setDisplay((prev) => ({ ...prev, value }));
  };

  return loading ? (
    <Loading fullScreen />
  ) : (
    <Fragment>
      <NumberPad prefix={display.prefix} value={display.value} setValue={(value) => setValue(value, setDisplay)} />
      {display.value && (
        <StatusBarButton
          label='Continue'
          icon='fas fa-chevron-right'
          reversed={true}
          clickHandler={proceed}
          statusSlot={5}
        />
      )}
    </Fragment>
  );
};

export default NumPlantsPerChannel;
